import { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '../../assets/icons/icons';
import { useConfig } from "../../contexts/ConfigContext";
import "./Evaluation.css";

const EvaluationLogin = ({ evaluation, onAuthorized }) => {
  const { config }                           = useConfig();  
  const [accessCode,     setAccessCode]      = useState("");
  const [showAccessCode, setShowAccessCode]  = useState(false);
  const [error, setError]                    = useState("");
  const { name, slug }                       = evaluation;

  // handle the access code entry
  const checkAccessCode = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        `${config.apiBase}/session`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ slug: slug, password: accessCode }),
        }
      );
      const session = await res.json();
      if (!res.ok) throw new Error(session.error || res.statusText);
      onAuthorized( session );
    } catch (e) {
      setError(e.message.replace(/</g, "&lt;"));
    }
  };

  const handleInput = (e) => {
     setAccessCode(e.target.value); 
  }

  return (
    <div className="web-view">
      <div className="evaluation-step-container">
        <div className="password-gate">
          <h2>{name || "Sports Wellness Survey"}</h2>
          <p>Please enter the access code provided to start the evaluation.</p>
          <form onSubmit={checkAccessCode}>
            <div className="accesscode-input-container">
              <div className="accesscode-input-wrapper">
                <input
                  type="text"
                  className={`accesscode-input ${showAccessCode ? "show" : "masked"}`}
                  value={accessCode}
                  onChange={e => { handleInput(e) }}
                  required
                  placeholder="Enter the access code"
                  name="accessCode"
                  autoComplete="off"
                />
                <button
                  type="button"
                  className="accesscode-toggle-icon"
                  aria-label={showAccessCode ? "Hide access code" : "Show access code"}
                  onClick={() => setShowAccessCode(v => !v)}
                  tabIndex={-1}
                >
                  {showAccessCode ? <EyeIcon /> : <EyeSlashIcon />}
                </button>
              </div>
              <span className="accesscode-error">{error}</span>
            </div>
            <br />
            <button type="submit">
              Start Evaluation
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default EvaluationLogin;
